export default __webpack_public_path__ + "static/media/OCULUS_ico.af58ff9d.svg";